"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountrySelectorStyles = exports.useCountryItemStyles = void 0;
const material_1 = require("@mui/material");
const useCountryItemStyles = () => {
    const flagStyle = {
        width: '24px',
        height: '24px',
        borderRadius: '61px',
    };
    return { flagStyle };
};
exports.useCountryItemStyles = useCountryItemStyles;
const useCountrySelectorStyles = () => {
    const theme = (0, material_1.useTheme)();
    const searchInputStyle = {
        height: '40px',
        '& > div.MuiInputBase-root': {
            height: '40px',
            '&:hover': {
                '&> fieldset': {
                    borderColor: theme.qlub.palette.dim.main,
                },
            },
            '&:focus-within': {
                '&> fieldset': {
                    borderColor: theme.palette.primary.main,
                },
            },
            '& > input': {
                padding: '16px 10px',
            },
            '&>svg': {
                color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
            },
            '&> fieldset': {
                borderColor: theme.qlub.palette.dim.main,
                '&:focus': {
                    borderColor: theme.palette.primary.main,
                },
            },
            '&.Mui-focused fieldset': {
                borderWidth: '1px',
            },
        },
    };
    const Container = {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        minWidth: '55px',
        justifyContent: 'center',
    };
    return { searchInputStyle, Container };
};
exports.useCountrySelectorStyles = useCountrySelectorStyles;
